module.exports = __webpack_public_path__ + "img/logo.f76f9bb4.png";